import { useMemo } from 'react';

import { combineUseQueryResult } from '@hcs/utils';

import { useCurrentOrgZuoraAccountCreated } from './useCurrentOrgZuoraAccountCreated';
import { useUserIsOrgPowerUser } from './useUserIsOrgPowerUser';

export const useUserHasBillingAccess = () => {
  const isPowerUserQuery = useUserIsOrgPowerUser();
  const hasZuoraAccountCreatedQuery = useCurrentOrgZuoraAccountCreated();
  const combinedQuery = combineUseQueryResult([
    isPowerUserQuery,
    hasZuoraAccountCreatedQuery,
  ]);

  const hasBillingAccess = useMemo(() => {
    if (combinedQuery.isSuccess) {
      const { data: isPowerUser } = isPowerUserQuery;
      const { data: hasCurrentOrgZuoraAccountCreated } =
        hasZuoraAccountCreatedQuery;
      return isPowerUser && hasCurrentOrgZuoraAccountCreated;
    }
    return undefined;
  }, [isPowerUserQuery.isSuccess, hasZuoraAccountCreatedQuery.isSuccess]);

  // Return whether user is 'Power User' and org has Zuora Account ID
  return {
    ...combinedQuery,
    data: hasBillingAccess,
  };
};
